import { render, staticRenderFns } from "./rationalization-detail.vue?vue&type=template&id=16a14720"
import script from "./rationalization-detail.vue?vue&type=script&lang=js"
export * from "./rationalization-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports